/**
 * Created by Qingger Corp.
 * User: tanjianzhen
 * Date: 2018-7-5
 * Time: 17:47
 * Desc:
 */
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import collect from 'collect.js';
import moment from 'moment';
import { groupBy, isEmpty } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import bindClassDialog from '../../newDisplayConfig/bindClassDialog';
import { globalElement } from '@/library/utils/globalElement';
import { IPSService } from '@/services/ipsServices';
import GoodsLink from '@/views/components/goodsLink/goodsLink.vue';
import { LIVE_STATE } from '@/views/pages/editVideo/editVideo';
import { QinggerLibUtils, noop } from '@/util';
import { Functions } from '@/library/utils/functions';
import baseAPIService from '@/services/base/baseAPIService';
import { EmpServiceAPIActions } from '@/services/empService';
import promotionLink from '@/views/components/linkForm/promotionLink';
const isset = QinggerLibUtils.isset;

// 1期刊、2商品、3商品列表、4直播、5秒杀、6团购、7活动、8促销
export enum LINK_TYPE {
  QIKAN = 1,
  GOOD,
  GOODLIST,
  LIVE,
  KILL,
  GROUP,
  ACTIVE,
  PROMOTION,
  GOOD_GROUP,
  NEW_PROMOTION,
}

// 活动类型  	活动类型可能包括：1发售活动、2促销活动、3互动活动、4报名活动 9全部
export const linkTypes = [
  { value: LINK_TYPE.QIKAN, label: '期刊' },
  { value: LINK_TYPE.GOOD, label: '商品' },
  { value: LINK_TYPE.GOODLIST, label: '商品分类' },
  { value: LINK_TYPE.LIVE, label: '直播' },
  { value: LINK_TYPE.KILL, label: '秒杀' },
  { value: LINK_TYPE.GROUP, label: '团购' },
  { value: LINK_TYPE.PROMOTION, label: '促销' },
];

Component.registerHooks([]);

@Component({
  components: {
    GoodsLink,
  },
})
export default class SwiperEditCp extends Vue {
  /* 属性 */

  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();

  /**
   * 轮播图
   * @type {ItemArray<ComponentsInfo>}
   */
  @Prop({ default: [] }) pictureList: ItemArray<ComponentsInfo>;
  /**
   * 视频地址
   * @type {string}
   */
  @Prop({ default: [] }) videoList: { url: '' };
  /**
   * 显示类型 0 默认 1自定义
   * @type {string}
   */
  @Prop({ default: '0' }) showType: string;

  /**
   * 父级组件名称
   * @type {string}
   */
  @Prop({ default: '' }) father: string;

  /**
   * 店铺logo配置
   * @type {string}
   */
  @Prop({ default: '0' }) showLogo: string;

  /**
   * 店铺名称配置 0 默认 1 自定义
   * @type {string}
   */
  @Prop({ default: '0' }) showName: string;

  /**
   * 店铺名称
   * @type {string}
   */
  @Prop({ default: '' }) name: string;

  /**
   * 店铺头像地址
   * @type {string}
   */
  @Prop({ default: '' }) logoUrl: string;

  linkTypeText(item) {
    return (this.linkSelect.find(i => i.value === item.linkType) || { label: '' }).label;
  }

  /* 数据 */

  /**
   * 选中的店铺名称配置
   * @type {string}
   */
  public nameTp = '0';

  /**
   * 店铺logo配置
   * @type {string}
   */
  public logoTp = '0';

  /**
   * 选中的活动类型
   * @type {string}
   */
  public selectValue = '';

  /**
   * 店铺logo
   * @type {string}
   */
  public shopLogo = '';

  /**
   * 店铺名称
   * @type {string}
   */
  public shopName = '';

  /**
   * 是否显示大图
   * @type {boolean}
   */
  public isMagnifyPopShow = false;

  /**
   * 下拉选择的网点
   * @type {string}
   */
  public selectedSite = '';

  /**
   * 图片上传地址
   * @type {string}
   */
  public imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * 是否显示活动弹窗
   * @type {boolean}
   */
  public isShowAct = false;

  /**
   * 是否显示期刊弹窗
   * @type {boolean}
   */
  public isShowPdc = false;

  /**
   * 是否显示商品弹窗
   * @type {boolean}
   */
  public isShowGds = false;

  public siteCodes: string[] = [];

  /**
   * 链接类型列表
   * @type {Array<string>}
   */
  public linkTypeList: Array<string> = ['期刊', '商品', '商品分类', '直播活动', '秒杀活动', '团购活动', '活动', '促销', '', '促销'];

  /**
   * 活动类型
   * @type {Array<any>}
   */
  public actType: Array<any> = [
    {
      value: 'SELL_ACT',
      label: '发售活动',
    },
    {
      value: 'SALE_ACT',
      label: '促销活动',
    },
    {
      value: 'INTER_ACT',
      label: '互动活动',
    },
  ];

  linkSelect = linkTypes;
  /**
   * 广告图保存前列表
   * @type {ItemArray<ComponentsInfo>}
   */
  public bgMapArrBefore: ItemArray<ComponentsInfo> = [];
  public picIndex = -1;

  /**
   * 店铺列表
   * @type {ItemArray<SiteInfo>}
   */
  public siteList: ItemArray<SiteInfo> = [];
  public siteCount = 0;

  /**
   * 活动列表
   * @type {ItemArray<ActivityInfo>}
   */
  public actArr: ItemArray<ActivityInfo> = [];
  public actCount = 0;

  /**
   * 期刊列表
   * @type {ItemArray<PeriodicalByPageConfig>}
   */
  public periodicalArr: ItemArray<PeriodicalByPageConfig> = [];
  public periodicalCount = 0;

  /**
   * 商品列表
   * @type {GoodsInfo}
   */
  public goodsArr: ItemArray<GoodsInfo> = [];

  /**
   * 活动列表请求参数
   * @type {ActivityRequestParam}
   */
  public activityRequestParam: ActivityRequestParam = {
    keyword: '',
  };

  /**
   * 期刊列表请求参数
   * @type {PeriodicalRequestParam}
   */
  public periodicalRequestParam: PeriodicalRequestParam = {
    keyword: '',
  };

  /**
   * 商品数据请求参数
   * @type {GoodsRequestParam}
   */
  public goodsRequestParam: GoodsRequestParam = {
    keyword: '',
  };

  /**
   * 活动当前页
   * @type {number}
   */
  public actPage = 1;

  /**
   * 期刊当前页
   * @type {number}
   */
  public qkPage = 1;
  public qkPageSize = 10;

  /**
   * 要添加链接的pic下标
   * @type {number}
   */
  public selectPicIndex = -1;

  /**
   * token
   * @type {ItemObject}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  /**
   * 显示方式
   * @type {string}
   */
  public typeTp = '0';

  /**
   * 视频地址
   * @type {string}
   */
  public videoObj: ItemObject = { url: '' };

  /**
   * 链接跳转类型
   * @type {string} 1 期刊 2 商品 3 商品列表 4 直播 5 秒杀 6 团购 7 活动
   */
  public linkType = '';

  public assembleShow = false;
  public liveShow = false;
  public skillShow = false;

  /**
   * 选中的 Item下表标
   * @type {number}
   */
  public selectedShopSketchIndex = 0;

  /**
   * 拼团搜索关键字
   * @type {string}
   */
  public ptKeyword = '';

  /**
   * 拼团列表
   * @type {Array<ItemObject>}
   */
  public assembleActivityList: Array<ItemObject> = [];

  /**
   * 拼团列表页码
   * @type {number}
   */
  public ptPage = 1;

  /**
   * 拼团列表每页显示数量
   * @type {number}
   */
  public ptPageSize = 10;

  /**
   * 拼团列表总数
   * @type {number}
   */
  public ptTotalCount = 0;

  /**
   * 直播间搜索关键字
   * @type {string}
   */
  public liveRoomKeywords = '';

  /**
   * 直播间列表
   * @type {Array<ItemObject>}
   */
  public liveRoomList: Array<ItemObject> = [];

  /**
   * 直播列表页码
   * @type {number}
   */
  public liveRoomPage = 1;
  /**
   * 直播列表显示数量
   * @type {number}
   */
  public liveRoomPageSize = 10;
  /**
   * 直播列表总数
   * @type {number}
   */
  public liveRoomTotalCount = 0;

  // 直播状态 101: 直播中, 102: 未开始, 103: 已结束, 104: 禁播, 105: 暂停中, 106: 异常, 107: 已过期
  liveStateText = {
    [LIVE_STATE.LIVE_ON]: '直播中',
    [LIVE_STATE.NO_START]: '未开始',
    [LIVE_STATE.END]: '已结束',
    [LIVE_STATE.CLOSE]: '禁播',
    [LIVE_STATE.PAUSE]: '暂停中',
    [LIVE_STATE.ERROR]: '异常',
    [LIVE_STATE.EXPIRED]: '已过期',
  };

  /**
   * 秒杀关键字
   * @type {string}
   */
  public skillKeywords = '';

  /**
   * 秒杀页码
   * @type {number}
   */
  public skPage = 1;

  /**
   * 秒杀每页显示数量
   * @type {number}
   */
  public skPageSize = 10;

  /**
   * 秒杀列表总数
   * @type {number}
   */
  public skTotalCount = 0;

  /**
   * 秒杀列表
   * @type {Array<ItemObject>}
   */
  public seckillList: Array<ItemObject> = [];

  /**
   * 绑定商品类型
   * @type {Array<ItemObject>}
   */
  public productType: Array<ItemObject> = [];

  public attrButeList = [];

  /**
   * 图片上传地址
   * @type {string}
   */
  public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  public onPropagandaUploadImgSuccess(res: HttpAPIRetItem<any>, file: any) {
    if (res && res.content) {
      this.$emit('update:logoUrl', res.content);
    } else {
      this.$message.error('图片上传失败');
    }
  }

  /**
   * 图片上传失败
   * @return null
   */
  public uploadImgError() {
    this.$message.error('图片上传失败');
  }

  /**
   * 监听店铺logo地址
   * @param val
   * @return null
   */
  @Watch('logoUrl', { deep: true })
  watchLogoUrl() {
    this.shopLogo = this.logoUrl;
  }

  /**
   * 图片上传之前
   * @param {ItemObject} file
   * @return boolean
   */
  public onBeforeUpload(file: ItemObject): boolean {
    const isJpg = file.type === 'image/jpeg';
    const isPng = file.type === 'image/png';
    const isGif = file.type === 'image/gif';
    const LtSize = file.size / 1024 <= 100;
    if (!isJpg && !isPng && !isGif) {
      this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!LtSize) {
      this.$message.error('上传图片大小不能超过 100Kb!');
    }
    return (isJpg || isPng || isGif) && LtSize;
  }

  /**
   * 切换店铺logo使用自定义还是默认
   * @param val
   * @return null
   */
  public onLogoTpChange() {
    this.$emit('update:showLogo', this.logoTp);
  }

  /**
   * 监听店铺logog配置切换
   * @param val
   */
  @Watch('showLogo', { deep: true })
  watchLogoTp() {
    this.logoTp = this.showLogo;
  }

  /**
   * 切换店铺名称使用自定义还是默认
   * @param val
   * @return {null}
   */
  public onNameTpChange() {
    this.$emit('update:showName', this.nameTp);
  }

  /**
   * 输入店铺名称
   * @param val
   * @return null
   */
  public onInputShopName(val) {
    this.$emit('update:name', val);
  }

  /**
   * 自定义店铺名称
   */
  @Watch('name', { deep: true })
  watchShopName() {
    this.shopName = this.name;
  }

  @Watch('showName', { deep: true })
  watchShowName() {
    this.nameTp = this.showName;
  }

  get getVAttributeValues() {
    let result: Array<String> = [];
    this.productType.forEach((item, indx) => {
      if (item.selectValues && item.selectValues.length > 0) {
        result = result.concat(item.selectValues);
      } else {
        result.push(item.attrCode);
      }
    });
    return result.toString();
  }

  getSwipeData() {
    return this.bgMapArrBefore;
  }

  /**
   * 刪除图片
   * @param {} null
   */
  public onDeletePic() {
    this.shopLogo = '';
    this.$emit('update:logoUrl', this.shopLogo);
  }

  /**
   * 图片放大
   * @return null
   */
  public onMagnifyPic(): void {
    this.isMagnifyPopShow = true;
  }

  /**
   * 选择要跳转的链接
   * @param {string} command
   */
  public handleCommand(command: string) {
    switch (command) {
      case '1':
        this.isShowAct = true;
        this.activityRequestParam.page = 1;
        this.activityRequestParam.pageNum = 10;
        this.activityRequestParam.keyword = '';
        this.getActTypeList();
        this.getActivityList();
        break;
      case '2':
        this.isShowPdc = true;
        this.periodicalRequestParam.page = 1;
        this.periodicalRequestParam.pageNum = 10;
        this.periodicalRequestParam.keyword = '';
        this.getPeriodicalList();
        break;
      case '3':
        // 暂时没有商品
        // this.isShowGds = true;
        // this.goodsArr = [];
        // this.getGoodsList();
        break;
      default:
        break;
    }
  }

  /**
   * 选择的图片item
   * @param {number} index
   */
  public selectPictureItem(index: number) {
    this.selectPicIndex = index;
  }

  /**
   * 选择的活动id
   * @param row
   */
  public chooseAct(row) {
    this.isShowAct = false;
    this.bgMapArrBefore[this.selectedShopSketchIndex].linkId = row.actId;
    this.bgMapArrBefore[this.selectedShopSketchIndex].linkName = row.actTitle;
  }

  /**
   * 选择的期刊id
   * @param row
   */
  public chooseQK(row) {
    this.linkType = `${LINK_TYPE.QIKAN}`;
    this.bgMapArrBefore.map((i) => {});
    this.isShowPdc = false;
    const temp = this.bgMapArrBefore.slice(this.selectedShopSketchIndex, this.selectedShopSketchIndex + 1)[0];
    this.bgMapArrBefore[this.selectedShopSketchIndex] = Object.assign({}, temp, {
      linkId: row.qiKanId,
      linkName: row.qiKanContent,
    });
    this.bgMapArrBefore[this.selectedShopSketchIndex].linkId = row.qiKanId;
    this.bgMapArrBefore[this.selectedShopSketchIndex].linkType = `${LINK_TYPE.QIKAN}`;
    this.bgMapArrBefore[this.selectedShopSketchIndex].linkName = row.qiKanContent;
  }

  /**
   * 选择的商品货号
   * @param row
   */
  public chooseGoods(row) {
    this.isShowGds = false;
    this.goodsArr = [];
  }

  /**
   * 图片上传之前的格式验证
   * @param file
   * @returns {boolean}
   */
  public beforeAvatarUpload(file) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const isGIF = file.type === 'image/gif';
    const isLt300K = file.size / 1024 <= 1024;
    if (!isJPG && !isPNG && !isGIF) {
      globalElement.message.error('上传图片只支持 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!isLt300K) {
      globalElement.message.error('上传图片大小不能超过 1M!');
    }
    return (isJPG || isPNG || isGIF) && isLt300K;
  }

  /**
   * 店铺Logo上传之前格式验证
   * @param res
   * @param file
   */
  public beforeLogoUpload(file) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const isGIF = file.type === 'image/gif';
    const isLt100K = file.size / 1024 <= 1024;
    if (!isJPG && !isPNG && !isGIF) {
      globalElement.message.error('上传图片只支持 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!isLt100K) {
      globalElement.message.error('上传图片大小不能超过 1M!');
    }
    return (isJPG || isPNG || isGIF) && isLt100K;
  }

  /**
   * 图片上传成功时的处理
   * @param res
   * @param file
   */
  public handleAvatarSuccess(res: HttpAPIRetItem<any>, file: any) {
    this.bgMapArrBefore[this.picIndex].imageUrl = res.content;
  }

  /**
   * 设置选中的图片下标
   * @param {number} index
   */
  public selectIndex(index: number) {
    this.picIndex = index;
  }

  /**
   * 上传图片成功
   * @param {HttpAPIRetItem<any>} res
   * @param file
   */
  public addHandleAvatarSuccess(res: HttpAPIRetItem<any>, file: any) {
    const pic: ComponentsInfo = {
      imageTitle: '',
      imageUrl: res.content,
      linkType: '',
      linkId: '',
    };
    this.bgMapArrBefore.push(pic);
  }

  /**
   * 删除轮播图
   * @param {number} index
   */
  public deletePic(index: number) {
    this.$confirm('确认删除删除此形象图吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then((res) => {
      if (res === 'confirm') {
        this.bgMapArrBefore.splice(index, 1);
      }
    });
  }

  /**
   * 删除链接
   * @param {number} index
   */
  public deleteSelect(index: number) {
    this.bgMapArrBefore[index].displayName = '';
    this.bgMapArrBefore[index].linkId = '';
    this.bgMapArrBefore[index].linkType = '';
  }

  /**
   * 上传失败提示
   * @param err
   */
  public uploadError(err) {
    const result = JSON.parse(err.message);
    if (result.message) {
      this.$message.error(result.message);
    }
  }

  /**
   * 打印拖拽后的图片列表Test
   */
  public sortIndex() {
    collect(this.bgMapArrBefore)
      .map<number>((item, index): any => {
        return item;
      })
      .all();
  }

  /**
   * 活动当前页
   * @param val
   */
  public handleActCurrentChange(val) {
    this.actPage = val;
    this.activityRequestParam.page = val;
    this.getActivityList();
  }

  /**
   * 每页显示条数
   * @param val
   */
  public selectedActPageNum(val) {
    this.activityRequestParam.pageNum = val;
    this.activityRequestParam.page = 1;
    this.actPage = 1;
    this.getActivityList();
  }

  /**
   * 期刊当前页
   * @param val
   */
  public handleQKCurrentChange(val) {
    this.qkPage = val;
    this.periodicalRequestParam.page = val;
    this.getPeriodicalList();
  }

  public selectedQKPageNum(val) {
    this.periodicalRequestParam.pageNum = val;
    this.periodicalRequestParam.page = 1;
    this.qkPage = 1;
    this.getPeriodicalList();
  }

  /**
   * 清除数据
   */
  public clearDialogData(type) {
    this.selectedSite = this.siteList.length > 0 ? this.siteList[0].siteName : '';
    this.selectValue = '';
    switch (type) {
      case 'ACT':
        this.activityRequestParam.actTypeId = 0;
        this.activityRequestParam.keyword = '';
        break;
      case 'QIKAN':
        this.periodicalRequestParam.keyword = '';
        break;
      case 'PRODUCT':
        this.goodsRequestParam.keyword = '';
        break;
      default:
        break;
    }
  }

  /**
   * 选择的网点
   * @param value
   */
  public selectSite(value) {
    if (this.isShowAct) {
      this.activityRequestParam.siteId = value;
      this.activityRequestParam.page = 1;
      this.actPage = 1;
      this.getActivityList();
    }
    if (this.isShowPdc) {
      this.periodicalRequestParam.page = 1;
      this.qkPage = 1;
      this.periodicalRequestParam.siteId = value;
      this.getPeriodicalList();
    }
    if (this.isShowGds) {
      this.goodsRequestParam.siteId = value;
    }
  }

  /**
   * 选择的活动
   * @param value
   */
  public selectAct(value) {
    this.activityRequestParam.actTypeId = value;
    this.activityRequestParam.page = 1;
    this.actPage = 1;
    this.getActivityList();
  }

  /**
   * 输入框失去焦点事件
   */
  public inputWordBlur() {
    if (this.isShowAct) {
      this.actPage = 1;
      this.activityRequestParam.page = 1;
      this.getActivityList();
    }
    if (this.isShowPdc) {
      this.periodicalRequestParam.page = 1;
      this.qkPage = 1;
      this.getPeriodicalList();
    }
    if (this.isShowGds) {
      if (this.goodsRequestParam.keyword) {
        this.getGoodsList();
      } else {
        this.goodsArr = [];
      }
    }
    if (this.liveShow) {
      this.getLiveRoomList();
    }

    if (this.assembleShow) {
      this.getAssembleList();
    }
    if (this.skillShow) {
      this.getSecKillList();
    }
  }

  /**
   * 输入的期刊关键字
   */
  public getInputWord(value) {
    if (this.isShowAct) {
      this.activityRequestParam.keyword = value;
    }
    if (this.isShowPdc) {
      this.periodicalRequestParam.keyword = value;
    }
    if (this.isShowGds) {
      this.goodsRequestParam.keyword = value;
    }
  }

  /**
   * 网点列表
   */
  public getSiteList(): void {
    if (this.father === 'displayConfig') {
      this.activityRequestParam.siteCodes = [this.$route.params.code];
      this.periodicalRequestParam.siteCodes = [this.$route.params.code];
      this.goodsRequestParam.siteCodes = [this.$route.params.code];
      this.siteCodes = [this.$route.params.code];
    } else {
      const queryParams = {
        sgId: Number.parseInt(this.$route.params.id),
      };
      IPSService.getSiteListByPageConfig({ queryParams }).then((res) => {
        if (isset(res, 'count')) {
          this.siteCount = res.count;
          this.siteList = res.list;
          if (!isEmpty(res.list)) {
            this.selectedSite = res.list[0].siteName;
            this.activityRequestParam.siteId = res.list[0].siteId;
            this.periodicalRequestParam.siteId = res.list[0].siteId;
            this.goodsRequestParam.siteId = res.list[0].siteId;
          }
        }
      });
    }
  }

  /**
   * 活动列表
   */
  public getActivityList(): void {
    const queryParams = this.activityRequestParam;
    this.actArr = [];
    IPSService.getActivityListByPageConfig({ queryParams }).then((res) => {
      if (isset(res, 'count')) {
        this.actArr = collect(res.list)
          .each((item) => {
            item.actStartTime = moment(item.actStartTime * 1000).format('YYYY-MM-DD HH:mm');
            item.actEndTime = moment(item.actEndTime * 1000).format('YYYY-MM-DD HH:mm');
          })
          .values()
          .toArray();
        this.actCount = res.count;
      }
    });
  }

  /**
   * 期刊列表
   */
  public getPeriodicalList(): void {
    const queryParams = this.periodicalRequestParam;
    queryParams.sort = 0;
    this.periodicalArr = [];
    IPSService.getPeriodicalList({ postParams: queryParams }).then((res) => {
      this.periodicalArr = collect(res.list)
        .each((item) => {
          item.qiKanEndTime = moment(item.qiKanEndTime * 1000).format('YYYY-MM-DD HH:mm');
        })
        .values()
        .toArray();
      this.periodicalCount = res.count;
    });
  }

  /**
   * 商品列表
   */
  public getGoodsList(): void {
    const queryParams = this.goodsRequestParam;
    this.goodsArr = [];
    IPSService.getGoodsListByPageConfig({ queryParams }).then((res) => {
      if (isset(res, 'list')) {
        this.goodsArr = res.list;
      }
    });
  }

  /**
   * 获得活动类型列表
   * @api
   */
  public getActTypeList(): void {
    const queryParams = {};
    IPSService.getActTypeList({ queryParams }).then((res) => {
      if (res.count > 0) {
        this.actType = res.list;
      } else {
        this.actType = [];
      }
    });
  }

  /**
   * 店铺页展示方式切换
   * @return null
   */
  public onShowTypeChange(): void {
    this.$emit('update:showType', this.typeTp);
  }

  /* 监听数据 */

  @Watch('showType', { deep: true })
  watchShowType() {
    this.typeTp = this.showType;
  }

  @Watch('pictureList', { deep: true })
  watchPictureList(n, o) {
    if (n && JSON.stringify(n) !== JSON.stringify(o)) {
      this.bgMapArrBefore = cloneDeep(n).map((v) => {
        return Object.assign({ linkId: '', linkType: '' }, v);
      });
    }
  }

  // 视频
  @Watch('videoList', { deep: true })
  watchVideoList() {
    this.videoObj = this.videoList;
    if (!this.videoList.url) {
      this.videoObj.url = '';
    }
  }

  /**
   * 获取关联分类
   */
  public getAttributeList(): Promise<any> {
    return IPSService.getAttrTreeList().then((res) => {
      return isset(res, 'list') ? res.list : [];
    });
  }

  setSelectGoods(item) {
    const list = [];
    // list = this.connectedClass.map((i) => {
    //     i.list.map((v) => {
    //       v.select = (item.linkList && item.linkList[0] ? item.linkList[0].linkId + "" || item.linkCodes : "")
    //         .split("_")
    //         .join(",")
    //         .split(",")
    //         .includes(v.value_no);
    //       return v;
    //     });
    //     return i;
    //   })
    //   .filter((i) => {
    //     return i.list.some((v) => v.select);
    //   });

    const select = item.linkId.split('_').join(',').split(',');
    const groupClass = groupBy(
      this.classStore.filter(v => select.includes(v.value_no)),
      'class_code',
    );
    const result = Object.keys(groupClass).map((i) => {
      return {
        attrCode: i,
        attrName: this.getAttrName(i),
        checkAll: true,
        selectNames: groupClass[i].map(v => v.value_name),
        selectValues: groupClass[i].map(v => v.value_no),
      };
    });
    return result;
  }

  getAttrName(attrCode) {
    return this.connectedClass.find((v) => {
      return v.attrCode === attrCode;
    }).attrName;
  }

  public connectedClass = [];

  public classStore = [];
  /* 周期 */
  public mounted() {
    this.bgMapArrBefore = cloneDeep(this.pictureList).map((v) => {
      return Object.assign({ linkId: '', linkType: '' }, v);
    });
    this.videoObj = this.videoList;

    // 获取商品列表
    this.getSiteList();
  }

  async created() {
    this.connectedClass = await this.getAttributeList();
    this.connectedClass = this.connectedClass.map((v) => {
      v.value_name = v.attrName;
      v.value_no = v.attrCode;
      v.class_code = v.attrCode;
      v.isLeafe = !v.list || !v.list.length;
      return v;
    });
    this.classStore = this.computedClass(this.connectedClass, []);
  }

  public computedClass(list = [], result = []) {
    list.forEach((v) => {
      result.push(v);
      if (v.list && v.list.length) {
        this.computedClass(v.list, result);
      }
    });
    return result;
  }

  /**
   * 选择跳转链接
   * @params val
   * @return null
   */
  public onLinkTypeChange(val, item, index) {
    // this.linkType = val;
    // item.linkType = val;
    this.selectedShopSketchIndex = index;
    // this.bgMapArrBefore.splice(index, 1, {
    //   imageUrl: this.bgMapArrBefore[index].imageUrl,
    //   linkType: this.linkType,
    //   linkId: "",
    //   linkName: "",
    // });
    // this.bgMapArrBefore[this.selectedShopSketchIndex] = Object.assign({},this.bgMapArrBefore[this.selectedShopSketchIndex],{linkId:"",linkName:"",linkType:val});

    this.openSelectDialog(val, item, index);
  }

  openSelectDialog(val, item?, index?) {
    switch (`${val}`) {
      case '1':
        this.isShowPdc = true;
        this.periodicalRequestParam.page = 1;
        this.periodicalRequestParam.pageNum = 10;
        this.periodicalRequestParam.keyword = '';
        this.getPeriodicalList();
        break;
      case '2':
        this.isShowGds = true;
        break;
      case '3':
        const defaultCheckedKeys = item.linkId.split('_').join(',').split(',');
        bindClassDialog.open({ defaultCheckedKeys }).then((res) => {
          item._productType = res;
          if (!res || !res.length) {
            item.linkType = null;
            return;
          }
          const classList = groupBy(
            res.filter(v => v.isLeafe),
            'class_code',
          );
          // const resValue = res
          //   .map((i: any) => {
          //     if ((i.selectValues && i.selectValues.length) || i.checkall) {
          //       return i.selectValues.join(",");
          //     }
          //   })
          //   .join("_");
          const resValue = Object.keys(classList)
            .map((v) => {
              return classList[v]
                .map((c) => {
                  return c.value_no;
                })
                .join(',');
            })
            .join('_');
          item.linkType = LINK_TYPE.GOODLIST;
          item.linkId = resValue;
          item.linkName = '';
          this.$set(this.bgMapArrBefore, index, item);
          this.$forceUpdate();
        }, noop);
        break;
      case '4':
        this.liveShow = true;
        this.liveRoomKeywords = '';
        this.liveRoomPage = 1;
        this.liveRoomPageSize = 10;
        this.inputWordBlur();
        break;
      case '5':
        this.skillShow = true;
        this.skillKeywords = '';
        this.skPage = 1;
        this.skPageSize = 10;
        this.getSecKillList();
        break;
      case '6':
        this.assembleShow = true;
        this.ptKeyword = '';
        this.ptPage = 1;
        this.ptPageSize = 10;
        this.getAssembleList();
        break;
      case '7':
        this.isShowAct = true;
        this.activityRequestParam.page = 1;
        this.activityRequestParam.pageNum = 10;
        this.activityRequestParam.keyword = '';
        this.getActTypeList();
        this.getActivityList();
        break;
      case '8':
      case '10':
        promotionLink.open({ siteCodes: this.siteCodes }).then((result) => {
          this.linkType = `${result.linkType}`;
          this.bgMapArrBefore[index] = Object.assign({}, this.bgMapArrBefore[index], {
            linkId: result.id,
            linkName: result.name,
            linkType: `${result.linkType}`,
          });
          this.$forceUpdate();
        }, noop);
        break;
      default:
        break;
    }
  }

  /**
   * 商品弹窗选择 商品
   * @return null
   */
  public handleGoodsSelect(val) {
    this.bgMapArrBefore[this.selectedShopSketchIndex] = Object.assign({}, this.bgMapArrBefore[this.selectedShopSketchIndex], { linkId: val[0].productCode, linkName: val[0].productName });

    this.linkType = `${LINK_TYPE.GOOD}`;
    this.bgMapArrBefore[this.selectedShopSketchIndex].linkType = `${LINK_TYPE.GOOD}`;
  }

  /**
   * 获取团购列表
   */
  public getAssembleList() {
    const postParams = {
      page: this.ptPage,
      ptState: 1,
      activityState: 4,
      keyword: this.ptKeyword,
      pageSize: this.ptPageSize,
      siteCodes: this.siteCodes,
    };
    IPSService.assembleActList({ postParams })
      .then((response) => {
        this.ptTotalCount = response.count;
        const result = response.list;
        // 格式化数据
        result.forEach((element) => {
          element.actBeginTime = Functions.timeFormatSec(element.actBeginTime);
          element.actEndTime = Functions.timeFormatSec(element.actEndTime);
          element.addTime = Functions.timeFormatSec(element.addTime);
        });
        this.assembleActivityList = result;
      })
      .catch((err) => {
        // console.log(err);
      });
  }

  /**
   * 获取秒杀列表
   * @param key
   */
  public getSecKillList() {
    this.seckillList = [];
    const postParams = {
      page: this.skPage,
      skState: 1,
      activityState: 4,
      siteCodes: this.siteCodes,
      pageSize: this.skPageSize,
      keyword: this.skillKeywords,
    };
    IPSService.secKillList({ postParams }).then((res: ItemObject) => {
      this.skTotalCount = res.count;
      // 格式化数据
      if (res.list.length > 0) {
        res.list.forEach((item) => {
          item.secKillName = Functions.emptyVaribleHandler(item.secKillName);
          item.productName = Functions.emptyVaribleHandler(item.productName);
          item.productCode = Functions.emptyVaribleHandler(item.productCode);
          item.updatePerson = Functions.emptyVaribleHandler(item.updatePerson);
          item.actBeginTime = Functions.timeFormatSec(item.actBeginTime);
          item.actEndTime = Functions.timeFormatSec(item.actEndTime);
          item.addTime = Functions.timeFormatSec(item.addTime);
          item.beforeBeginTime = Functions.timeFormatSec(item.beforeBeginTime);

          // 计算秒杀价
          let sold = 0;
          let seckillStock = 0;
          item.proportion = item.seckillStock ? `${(item.sold * 100) / item.seckillStock}%` : '0%';
          // 累加库存
          if (item.skuItems && item.skuItems.length > 0) {
            // 写入已售库存 和 占比
            item.skuItems.forEach((sItem) => {
              sItem['sold'] = sItem.totalStock - sItem.hasStock; // 已售库存
              const proportion1 = sItem.totalStock > 0 ? (sItem.sold * 100) / sItem.totalStock : 0;
              sItem['proportion'] = proportion1 > 0 ? `${proportion1.toFixed(2)}%` : '0%'; // 已售库存
              sItem.specVal = Functions.emptyVaribleHandler(sItem.specVal); // 规格
            });
            // 计算规格总数
            item.skuItems.forEach((sItem) => {
              seckillStock = seckillStock + sItem.totalStock; // 总库存
              sold = sold + sItem.sold; // 已售库存
            });
          }

          item['seckillStock'] = seckillStock; // 秒杀库存
          item['sold'] = sold; // 已售库存
          const proportion2 = seckillStock > 0 ? (sold * 100) / seckillStock : 0;
          item['proportion'] = proportion2 > 0 ? `${proportion2.toFixed(2)}%` : '0%';
        });
      }

      this.seckillList = res.list;
    });
  }

  /**
   * 获取直播间列表
   * @param key
   */
  public getLiveRoomList() {
    const param = {
      siteCodes: Array.of(this.$route.params.code),
      page: this.liveRoomPage,
      pageNum: this.liveRoomPageSize,
      keywords: this.liveRoomKeywords,
    };

    IPSService.liveViewList({ postParams: param }).then(
      (res) => {
        this.liveRoomList = res.list.map((i) => {
          i = Object.assign({}, i, {
            actTime: `${moment(i.actBeginTime * 1000).format('YYYY-MM-DD HH:mm')}~${moment(i.actEndTime * 1000).format('YYYY-MM-DD HH:mm')}`,
            lvBeginTime: moment(i.lvBeginTime * 1000).format('YYYY-MM-DD HH:mm'),
          });
          return i;
        });
        this.liveRoomTotalCount = res.count;
      },
      (err) => {},
    );
  }

  /**
   * 拼团列表 pageSize切换
   * @return null
   */
  public onPTPageChange(val) {
    this.ptPage = val;
    this.getAssembleList();
  }

  /**
   * 拼团页码切换
   * @return null
   */
  public onPTSizeChange(val) {
    this.ptPageSize = val;
    this.getAssembleList();
  }

  /**
   * 拼团选中
   * @return null
   */
  public handlePTSelect(val) {
    this.assembleShow = false;
    const temp = this.bgMapArrBefore.slice(this.selectedShopSketchIndex, this.selectedShopSketchIndex + 1)[0];
    this.bgMapArrBefore[this.selectedShopSketchIndex] = Object.assign({}, temp, {
      linkId: val.ptId,
      linkName: val.ptName,
    });
    this.linkType = `${LINK_TYPE.GROUP}`;
    this.bgMapArrBefore[this.selectedShopSketchIndex].linkType = `${LINK_TYPE.GROUP}`;
  }

  /**
   * 直播间选中
   * @return null
   */
  public handleLiveRoomSelect(val) {
    this.bgMapArrBefore[this.selectedShopSketchIndex].linkName = val.lvName;
    this.bgMapArrBefore[this.selectedShopSketchIndex].linkId = val.lvId;
    this.liveShow = false;
    this.linkType = `${LINK_TYPE.LIVE}`;
    this.bgMapArrBefore[this.selectedShopSketchIndex].linkType = `${LINK_TYPE.LIVE}`;
  }

  /**
   * 直播列表显示条数切换
   * @return null
   */
  public onLiveRoomSizeChange(val) {
    this.liveRoomPageSize = val;
    this.getLiveRoomList();
  }

  /**
   * 直播列表页码切换
   * @return null
   */
  public onLiveRoomPageChange(val) {
    this.liveRoomPage = val;
    this.getLiveRoomList();
  }

  /**
   * 秒杀列表选中
   * @return null
   */
  public handleSKSelect(row) {
    this.skillShow = false;

    const temp = this.bgMapArrBefore.slice(this.selectedShopSketchIndex, this.selectedShopSketchIndex + 1)[0];
    this.bgMapArrBefore[this.selectedShopSketchIndex] = Object.assign({}, temp, {
      linkId: row.skId,
      linkName: row.secKillName,
    });

    this.linkType = `${LINK_TYPE.KILL}`;
    this.bgMapArrBefore[this.selectedShopSketchIndex].linkType = `${LINK_TYPE.KILL}`;
  }

  /**
   * 秒杀显示熟练切换
   * @return null
   */
  public onSKSizeChange(val) {
    this.skPageSize = val;
    this.getSecKillList();
  }

  /**
   * 秒杀切换页码
   * @return null
   */
  public onSKPageChange(val) {
    this.skPage = val;
    this.getSecKillList();
  }

  /**
   * 去除链接
   */
  public deleteLink(index) {
    this.bgMapArrBefore.splice(index, 1, {
      imageUrl: this.bgMapArrBefore[index].imageUrl,
      linkType: '',
      linkId: '',
      linkName: '',
    });
  }

  /**
   * 移除选择分类
   * @return null
   */
  public handleDeleteSelect(pindex, index, codes?) {
    if (codes) {
      const item: any = this.bgMapArrBefore[index];
      // item._productType = item._productType.filter((v, i) => {
      //   return i !== pindex - 1;
      // });
      const linkCodeslist = item.linkId.split('_');
      linkCodeslist.splice(pindex - 1, 1);
      item.linkId = linkCodeslist.join('_');
      // item.linkId = linkCodeslist
      //   .map((v) => {
      //     return v
      //       .split(",")
      //       .filter((i) => {
      //         return !codes.includes(i);
      //       })
      //       .join(",");
      //   })
      //   .filter((i) => i)
      //   .join("_");
      if (!item.linkId) {
        item.linkType = null;
      }
      this.bgMapArrBefore[index] = item;
      this.$forceUpdate();
    }
  }

  /**
   * 计算选择商品列表显示文字
   * @return string
   */
  public getSelectTypeName(item) {
    let result: string = item.attrName;
    if (item.selectValues && item.selectValues.length > 0) {
      result += `-${item.selectNames.toString()}`;
    }
    return result;
  }
}
